import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { GlobalAccount, GUID, Portfolio } from '@ndvr/portfolio-api';

import { usePortfolioSelector } from 'views/billing/widgets/usePortfolioSelector';
import { Text } from 'widgets';

interface Props {
    name: string;
    globalAccountGUID: GUID<GlobalAccount>;
    excludedPortfolios?: GUID<Portfolio>[];
    disabled?: boolean;
    hideLabel?: boolean;
    allowEmpty?: boolean;
}

export const PortfolioSelect = ({
    name,
    globalAccountGUID,
    excludedPortfolios,
    disabled,
    hideLabel,
    allowEmpty,
}: Props) => {
    const {
        watch,
        setValue,
        formState: { errors },
    } = useFormContext();
    const portfolioGUID = watch(name);

    const { PortfolioSelector, selectedPortfolio, reset } = usePortfolioSelector(
        globalAccountGUID,
        portfolioGUID,
        excludedPortfolios,
    );

    useEffect(() => {
        if (selectedPortfolio && excludedPortfolios?.includes(selectedPortfolio?.portfolioGUID)) {
            reset();
        }
    }, [excludedPortfolios, reset, selectedPortfolio]);

    useEffect(() => {
        setValue(name, selectedPortfolio?.portfolioGUID);
    }, [name, selectedPortfolio, setValue]);

    return (
        <>
            <PortfolioSelector disabled={disabled} hideLabel={hideLabel} clearable={allowEmpty} />
            {errors[name] && <Text $themeColor="negative">{errors[name]?.message?.toString()}</Text>}
        </>
    );
};
